<template>
	<div class="overlay" :class="{ 'overlayActive': addingCart }"></div>
	<div v-if="logCart" style="width:100%;position:fixed;top:10px;height:30px;background-color:rgba(0, 128, 0, 0.822);z-index:9999">
		<h3 style="color:white" id="addedToCart">Aggiunto al Carrello!</h3>
	</div>
	<div :style="visibleBottomBar ? 'display:flex' : 'display:none!important'"
		style="z-index:9;width:100%;position:fixed;justify-content:center;align-items:center;bottom:0px;height:140px;padding:10px;background-color:#f3f3f3"
		class="border border-5 d-none d-md-flex">
		<div style="display:flex;flex-direction: row;">
			<div class="productHead" style="padding-right:10px">
				<div class="productName" @click="openModalPr">
					<BaseProduct v-if="selectedProduct" :data="selectedProduct" :type="'small'"></BaseProduct>
					<button v-else class="btn btn-lg btn-light" id="productPickerBanner">Scegli il prodotto</button>
				</div>
			</div>
			<div class="colorHead" style="padding-left:10px" @click="openModalCo">
				<div>
					<BaseColor v-if="selectedColor" :data="selectedColor" :type="'small'"></BaseColor>
					<button v-else class="btn btn-lg btn-light" id="colorPickerBanner">Scegli Colore</button>
				</div>
			</div>
		</div>
		<div style="display:flex;flex-direction: column;padding:10px">
			<div class="packagings m-3" v-if="selectedProduct && selectedColor">
				<button v-for="(option, i) in sizes" :key="i" class="m-1 btn"
					:class="option.sizeFormValue == selectedSize ? 'btn-dark' : 'btn-light'" @click="selectSize(option)"
					:disabled="option.sizeFormValue == selectedSize">{{ option.sizeLabel }}</button>
			</div>
			<button class="btn btn-dark" @click="openModalResa" id="calculatorBanner">Calcolatore
				Mq</button>
		</div>

		<div class="quantity m-3" v-if="selectedProduct && selectedColor" style="display:flex;flex-direction: column;">
			<div style="display:flex;flex-direction: row;align-items: center;">
				<div style="display:flex;flex-direction: row;height:35px">
					<button class="btn btn-light" @click="quantità > 1 ? quantità-- : quantità == quantità">-</button>
					<input style="width:35px" id="quantity" type="number " v-model="quantità">
					<button @click="quantità++" class="btn btn-light">+</button>
				</div>
				<div v-if="selectedProduct && selectedSize && selectedColor" class="productPrice m-3">
					<h2 v-if="priceTotal > 0" style="color:#264151">{{ priceTotal }} €</h2>
					<img v-if="priceTotal == 0" :src="`${imgPath}loading.gif`">
				</div>
			</div>

			<button class="btn btn-dark" @click="addToCart" id="addToCartBanner">Aggiungi al Carrello</button>
		</div>

	</div>
	<div class="container" :class="selectedProduct || selectedColor ? 'contWhite' : ''">
		<div class="row">
			<div class="col-lg-8 col-12 order-lg-1 order-1">
				<div v-if="selectedProduct && selectedColor && selectedProduct.ambienteImage.length > 0">
					<!-- <img v-if="selectedProduct && selectedColor" :src="imageSrc" style="max-width:100%"> -->

					<Carousel style="width:100%">
						<Slide v-for="(slide, i) in selectedProduct.ambienteImage" :key="i"
							style="height:100%;overflow: hidden;"
							:style="selectedColor ? `background-color:${selectedColor.hexColor}` : `background-color:none`">
							<div class="carousel__item"><img style="width:100%" :src="slide"></div>
						</Slide>
						<template #addons>
							<Navigation />
							<Pagination style="background-color:white;margin-top:0px" />
						</template>
					</Carousel>
				</div>
				<div v-if="selectedProduct && selectedProduct.tds">
					<a :href="`https://loggia.docs-online.it/pages/prodotto.php?titolo=${selectedProduct.tds}&lang=1`"
						target="_blank"><button class="btn btn-dark" id="tds">Scheda Tecnica</button></a>
					<a :href="`https://loggia.docs-online.it/pages/prodotto.php?titolo=${selectedProduct.tds}&lang=1`"
						target="_blank"><button class="btn btn-dark" id="sds">Scheda Sicurezza</button></a>
					<a v-if="selectedProduct.videoApplicativo" :href="selectedProduct.videoApplicativo"
						target="_blank"><button class="btn btn-dark" id="video">Video Applicativo</button></a>
					<button v-else class="btn btn-dark" id="video" disabled>Video Applicativo</button>
				</div>
				<div v-else-if="selectedProduct">
					<button v-if="selectedProduct" class="btn btn-dark" id="tds" disabled>Scheda Tecnica</button>
					<button v-if="selectedProduct" class="btn btn-dark" id="sds" disabled>Scheda Sicurezza</button>
					<button v-if="selectedProduct" class="btn btn-dark" id="video" disabled>Video Applicativo</button>
				</div>
				<div class="productLongDesc m-3">
					<h3 v-if="selectedProduct && selectedProduct.description.length > 0" id="description">Descrizione</h3>
					<div v-html="selectedProduct ? selectedProduct.description : ''" id="descriptionText"></div>
				</div>
			</div>
			<div class="col-lg-4 col-12 order-lg-2 order-2 text-start">
				<div class="productHead">
					<div class="productName m-3" @click="openModalPr" style="display:flex">
						<BaseProduct v-if="selectedProduct" :data="selectedProduct" :type="'big'">
						</BaseProduct>
						<button class="btn btn-lg btn-light" v-if="selectedProduct" id="changeProduct">Cambia</button>
						<button v-else class="btn btn-lg btn-light" id="productPicker">Scegli il prodotto</button>
					</div>
					<div class="productShortDesc m-3">
						<p style="color:grey">{{ selectedProduct ? selectedProduct.shortDescription : "" }}</p>
					</div>
				</div>
				<div class="colorHead m-3" @click="openModalCo">
					<div style="display:flex">
						<BaseColor v-if="selectedColor" :data="selectedColor" :type="'big'"></BaseColor>
						<button class="btn btn-lg btn-light" v-if="selectedColor" id="changeColor">Cambia</button>
						<button v-else class="btn btn-lg btn-light" id="colorPicker">Scegli Colore</button>
					</div>
				</div>
				<div class="m-3">
					<button @click="openPainter" class="btn btn-success">Prova il colore!</button>
				</div>
				<div v-if="selectedProduct && selectedSize && selectedColor" class="productPrice m-3">
					<h2 v-if="priceTotal > 0" style="color:#264151">{{ priceTotal }} €</h2>
					<img v-if="priceTotal == 0" :src="`${imgPath}loading.gif`">
				</div>
				<div class="packagings m-3" v-if="selectedProduct && selectedColor">
					<button v-for="(option, i) in sizes" :key="i" class="m-1 btn"
						:class="option.sizeFormValue == selectedSize ? 'btn-dark' : 'btn-light'" @click="selectSize(option)"
						:disabled="option.sizeFormValue == selectedSize">{{ option.sizeLabel }}</button>
					<button class="btn btn-dark" @click="openModalResa" id="calculator">Calcolatore
						Mq</button>
				</div>
				<div class="reset m-3"
					v-if="selectedProduct || selectedPalette && selectedPalette !== true || selectedColor">
					<strong>
						<p style="color:red;cursor:pointer;" @click="reset('all')" id="optionsReset">Reset opzioni</p>
					</strong>
				</div>
				<div class="quantity m-3" v-if="selectedProduct && selectedColor">
					<button class="btn btn-light" @click="quantità > 1 ? quantità-- : quantità == quantità">-</button>
					<input style="width:100px" id="quantity" type="number " v-model="quantità">
					<button @click="quantità++" class="btn btn-light">+</button>
					<button class="btn btn-dark" @click="addToCart" id="addToCart">Aggiungi al Carrello</button>
					<!-- <button class="btn btn-dark" @click="addToCartFissativo" id="addToCart">Aggiungi Fissativo al Carrello</button> -->
				</div>

				<div id="scrollObj" ref="scrollObj"></div>
			</div>
		</div>
	</div>




	<div class="modal fade" tabindex="-1" aria-hidden="true" ref="modalPr">
		<div class="modal-dialog modal-fullscreen">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title" id="selectProductLabel">Seleziona Prodotto</h5>
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
						@click="closeModalPr"></button>
				</div>
				<div class="modal-body">
					<div class="productBody"
						style="display: flex;justify-content: center;flex-wrap: wrap;flex-direction: row;">
						<BaseProduct v-for="(product, i) in products" :key="i" @selectPr="selectPr(product)" :data="product"
							:type="'big'"></BaseProduct>
					</div>
				</div>
				<div class="modal-footer">
				</div>
			</div>
		</div>
	</div>

	<div class="modal fade" tabindex="-1" aria-hidden="true" ref="modalCo">
		<div class="modal-dialog modal-fullscreen">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title" id="selectColorLabel">Seleziona Colore</h5>
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
						@click="closeModalCo"></button>
				</div>
				<div class="modal-body">
					<div class="notesForm">
						<h3 id="palettesLabel">Palettes:</h3>
						<button class="btn" :class="selectedPalette === true ? 'btn-dark' : 'btn-light'"
							@click="selectAllPa()" :disabled="selectedPalette === true" id="allColors"
							style="color:black !important">Tutti i colori</button>
						<button class="btn"
							:class="selectedPalette && palette.id == selectedPalette.id ? 'btn-dark' : 'btn-light'"
							v-for="(palette, i) in palettes" :key="i" @click="selectPa(palette)"
							:disabled="selectedPalette && palette.id == selectedPalette.id"
							:style="palette.color ? `background-color:${palette.color}` : ''"
							style="color:black !important"> {{ palette.name }}</button>
					</div>
					<div v-if="!!selectedPalette">
						<h3 id="colorsLabel">Colori:</h3>
						<input v-model="searchFilter" placeholder="Cerca.." type="text" style="width:250px;margin:auto">
						<div class="p-3" style="display:flex;flex-direction:row;justify-content:center">
							<BaseCentroid v-for="(centroid, i) in centroidsAvailable" :key="i" :data="centroid"
								@click="filterColors(i)"></BaseCentroid>
						</div>
						<div style="display:flex;flex-direction:row;justify-content: center;flex-wrap: wrap;">
							<BaseColor v-for="color in filteredColors" :key="color.id" @click="selectCo(color)"
								:data="color" :type="'big'">
							</BaseColor>
						</div>
					</div>
				</div>
				<div class="modal-footer">
				</div>
			</div>
		</div>
	</div>

	<div class="modal fade" tabindex="-1" aria-hidden="true" ref="modalResa">
		<div class="modal-dialog modal-xl">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title" id="calculatorLabel">Calcolo Confezioni</h5>
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
						@click="closeModalResa"></button>
				</div>
				<div class="modal-body">
					<div v-if="selectedProduct && selectedColor && selectedSize" class="p-5"
						style="display:flex;flex-direction:column;justify-content: center;">
						<div style="display:flex;flex-direction:row;justify-content: center;">
							<button @click="changeInput('mq')" class="btn btn-sm"
								:class="modInput == 'mq' ? 'btn-dark' : 'btn-light'" id="calculatorMeterSquares">Metri
								quadrati</button>
							<button @click="changeInput('pareti')" class="btn btn-sm"
								:class="modInput == 'pareti' ? 'btn-dark' : 'btn-light'" id="calculatorWalls">Dimensione
								Pareti</button>
						</div>
						<div class="container">
							<div class="borders p-2" style="display: flex;flex-direction: column;align-items: center;">
								<div v-if="modInput == 'mq'">
									<p style="color:red" id="valuesMt">Inserire valori in mq</p>
									<input v-model="inputMq" min="0" type="number">
								</div>
								<div v-else-if="modInput == 'pareti'"
									style="display:flex;flex-direction:column;align-items: center;width:200px">
									<p style="color:red" id="valuesCm">Inserire valori in m</p>
									<table class="table">
										<thead>
											<tr>
												<td id="calculatorWidth">Larghezza</td>
												<td id="calculatorheight">Altezza</td>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(parete, i) in inputPareti" :key="i" class="borders">
												<td><input style="width:60px" type="number" min="0" v-model="parete.x"></td>
												<td><input style="width:60px" type="number" min="0" v-model="parete.y">
													<div v-if="i != 0" class="button_minus"
														@click="inputPareti.splice(i, 1)">
													</div>
												</td>
											</tr>
										</tbody>
									</table>
									<div class="button_plus" @click="inputPareti.push({ x: 0, y: 0 })"></div>
								</div>
								<p class="pt-3">N. Mani:</p>
								<p style="color:red">Per il corretto impiego di questo prodotto sono necessarie 2 mani di verniciatura.</p>
								<div class="maniSelector" style="display:flex;flex-direction:row">
									<div class="button_minus" @click="(inputMani>2)?inputMani--:inputMani=inputMani" style="top:0;left:0"></div>
									<input v-model="inputMani" min="2" type="number" style="width:50px" class="me-0">
									<div class="button_plus" @click="inputMani++" style="top:0;left:0"></div>
								</div>
							</div>

							<table class="table table-sm">
								<thead>
									<tr>
										<th id="calculatorSize">Confezione</th>
										<th id="calculatorQuantity">Quantità</th>
									</tr>
								</thead>
								<tr v-for="(conf, i) in resa" :key="i">
									<td>{{ conf.confezione }}</td>
									<td>{{ conf.quantità }}</td>
								</tr>
							</table>
							<h2>{{ prezzoCalc }}€</h2>
							<button class="btn btn-dark" @click="addManyToCart" id="addAllToCart">Aggiungi tutti al
								carrello</button>
						</div>
					</div>
				</div>
				<div class="modal-footer">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import { ref, onMounted, watch, computed } from 'vue'
import { useRoute } from 'vue-router'
import { Modal } from 'bootstrap'
import BaseColor from '../components/BaseColor.vue'
import BaseProduct from '../components/BaseProduct.vue'
import BaseCentroid from '../components/BaseCentroid.vue'
import productsMethods from "../api/resources/productsMethods"
import palettesMethods from "../api/resources/palettesMethods"
import colorsMethods from "../api/resources/colorsMethods"
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'
// import loadingGif from '../assets/loading.gif'
export default {
	name: 'HomeView',
	components: {
		BaseColor, BaseProduct, BaseCentroid, Carousel,
		Slide,
		Pagination,
		Navigation,
	},

	setup() {
		const modalPr = ref(null); //modal Selezione prodotto
		const modalCo = ref(null); //modal Selezione colore
		const modalResa = ref(null); //modal simulatore resa
		var modalProduct = Modal;
		var modalColor = Modal;
		var modalRe = Modal;
		const products = ref([]); //array prodotti
		const palettes = ref([]); //array palettes
		const imageSrc = ref(null); //src immagine variazione
		const colors = ref([]); //array colori
		const filteredColors = ref([]); //array colori filtrati da visualizzare
		const selectedProduct = ref(null); //oggetto prodotto selezionato
		const selectedPalette = ref(null); //oggetto palette selezionata
		const selectedColor = ref(null); //oggetto colore selezionato
		const selectedSize = ref(null); //oggetto dimensione selezionata
		const sizes = ref(null); //array dimensioni
		const price = ref(null); //prezzo dimensione
		var resaF = 1; //resa DA RICEVERE DA API
		const quantità = ref(1); //quantità selezionate
		const inputMq = ref(null); //input metri quadrati simulatore
		const inputPareti = ref([{ x: 0, y: 0 }]);
		const inputMani = ref(2);
		const modInput = ref("mq");
		const centroidsAvailable = ref(null); //centroidi calcolati su colori disponibili
		const labelsAvailable = ref(null); //array di assegnazione coloreIndex => centroideIndex
		const imgPath = window.location.origin + "/wp-content/plugins/loggiaColors/views/img/"; //
		const styleBackgroundLoading = "url('" + imgPath + "loading.gif')";
		const logCart = ref(false);
		const addingCart = ref(false);
		const searchFilter = ref(null);
		const scrollObj = ref(null);
		// const controller = new AbortController()
		// const signal = controller.signal
		var elemRect = null;
		var bodyRect = null;
		var offset = null;
		const visibleBottomBar = ref(false);
		function openModalPr() {
			modalProduct.show()
		}

		function openModalCo() {
			modalColor.show()
		}

		function openModalResa() {
			modalRe.show()
		}

		async function loadProducts() {
			products.value = null;
			if (!selectedColor.value) {
				var result = await productsMethods.loadProducts();
				products.value = result;
			}
			else {
				products.value = await productsMethods.loadProductsByColor(selectedColor.value.term_id);
			}
		}

		async function loadPalettes() {
			palettes.value = null;
			if (!selectedProduct.value) {
				var result = await palettesMethods.loadPalettes();
				palettes.value = result;
				selectAllPa();
			}
			else {
				palettes.value = await palettesMethods.loadPalettesByProduct(selectedProduct.value.id);
				selectAllPa();
			}
		}

		async function loadColors() {
			let prodId;
			selectedProduct.value ? (prodId = selectedProduct.value.id) : (prodId = 0);
			let obj = {
				cartId: selectedPalette.value.id,
				prodId: prodId
			}
			colors.value = await palettesMethods.loadColors(obj);
			filteredColors.value = colors.value;
		}

		async function selectPr(obj,init=false) {
			selectedSize.value = null;
			selectedProduct.value = obj;
			if (isNaN(parseInt(obj.resa))) {
				resaF = 1;
			}
			else {
				resaF = parseInt(obj.resa);
			}
			addingCart.value = true;
			if(!init){
				await loadPalettes();
			}
			addingCart.value = false;
			getSizes(obj.id);
			closeModalPr();
			if (!selectedColor.value) {
				openModalCo();
			}
		}
		async function selectPa(obj) {
			selectedPalette.value = obj;
			// console.log("carico colori")
			if (!selectedProduct.value) {
				centroidsAvailable.value = [];
				filteredColors.value = [];
				colors.value = await palettesMethods.loadColorsByPalette(selectedPalette.value.id)
				filteredColors.value = colors.value;
				if (searchFilter.value && searchFilter.value.length > 0) {
					filteredColors.value.forEach(element => {
						if (!element.name.toLowerCase().includes(searchFilter.value.toLowerCase())) {
							element.show = false;
						}
						else {
							element.show = true;
						}
					})
				}
			}
		}
		async function selectAllPa() {
			selectedPalette.value = true;
			centroidsAvailable.value = [];
			filteredColors.value = [];
			//creo oggetto da inviare per richiesta con lista palettes e prodotto selezionato
			let prodId;
			selectedProduct.value ? (prodId = selectedProduct.value.id) : (prodId = 0);
			let obj = {
				palettes: palettes.value,
				prodId: prodId
			};
			colors.value = await palettesMethods.loadAllColors(obj);
			filteredColors.value = colors.value;
		}
		async function selectCo(obj) {
			selectedColor.value = obj;
			addingCart.value = true;
			await loadProducts();
			addingCart.value = false;
			closeModalCo();
			if (!selectedProduct.value) {
				openModalPr();
			}
		}
		function selectSize(obj) {
			selectedSize.value = obj.sizeFormValue;
		}

		function closeModalPr() {
			modalProduct.hide()
		}
		function closeModalCo() {
			modalColor.hide()
		}
		function closeModalResa() {
			modalRe.hide()
		}
		onMounted(init)
		async function init() {
			addingCart.value = true
			//carica i modals, controlla i parametri di input e carica la preselezione di prodotti/palette
			modalProduct = new Modal(modalPr.value);
			modalColor = new Modal(modalCo.value);
			modalRe = new Modal(modalResa.value);

			bodyRect = document.body.getBoundingClientRect();
			elemRect = scrollObj.value.getBoundingClientRect();
			offset = elemRect.top - bodyRect.top;
			window.addEventListener('scroll', scroll);


			let type = useRoute().params.type;
			var id = useRoute().params.id;
			let idSec = useRoute().params.idSecond;
			await loadProducts();
			await loadPalettes();
			//preseleziono il prodotto con il parametro product nella route
			if (type == "product") {
				// addingCart.value = true
				if(id){
					if (id != 0) {
						products.value.forEach(element => {
							if (element.id == id) {
								selectPr(element);
								openModalCo();
							}
						})
					}
					else {
						openModalCo();
					}
				}
				else{
					openModalPr();
				}
			}
			//preseleziono la palette con il parametro palette nella route
			else if (type == "palette") {
				// addingCart.value = true
				if(id){
					palettes.value.forEach(element => {
						if (element.id == id) {
							selectPa(element);
							openModalCo();
						}
					})
				}
				else{
					openModalCo();
				}
			}
			//preseleziono il colore
			else if(type == "color"){
				let obj = {
				palettes: palettes.value,
				prodId: 0
				};
				colors.value = await palettesMethods.loadAllColors(obj);
				colors.value.forEach(element => {
					if (element.term_id == id) {
						selectCo(element);
					}
				})
				openModalPr();
			}
			//preseleziono il prodotto e il colore con il parametro variation/idProdotto/idTermColore
			else if (type == "variation") {
				// addingCart.value = true
				selectedColor.value = {id:"temp"};
				products.value.forEach(element => {
					if (element.id == id) {
						selectPr(element,true);
						//openModalCo();
					}
				})
				let obj = {
				palettes: palettes.value,
				prodId: id
				};
				colors.value = await palettesMethods.loadAllColors(obj);
				colors.value.forEach(element => {
					if (element.term_id == idSec) {
						selectCo(element);
					}
				})
				//ricarico le palette per visualizzare solo le palettes del prodotto selezionato
				loadPalettes();
				// addingCart.value = false
			}
			else{
				openModalPr();
			}
			addingCart.value = false
		}

		function scroll() {
			if (window.scrollY > offset) {
				visibleBottomBar.value = true;
			}
			else {
				visibleBottomBar.value = false;
			}
		}

		function reset(type) {
			//resetta le selezioni di prodotto, colore e dimensione
			if (type == "product") {
				selectedProduct.value = null;
				imageSrc.value = null;
				price.value = null;
				loadPalettes();
			}
			if (type == "color") {
				selectedColor.value = null;
				imageSrc.value = null;
				price.value = null;
				loadProducts();
			}
			if (type == "all") {
				selectedProduct.value = null;
				selectedPalette.value = null;
				selectedSize.value = null;
				selectedColor.value = null;
				price.value = null;
				loadProducts();
				loadPalettes();
			}
			openModalPr();
		}

		async function getSizes(id) {
			//carica le dimensioni disponibili per il prodotto
			sizes.value = await productsMethods.getSizes(id);
			if (sizes.value.length > 0) {
				selectedSize.value = sizes.value[0].sizeFormValue;
			}
		}
		async function getPriceAndVideo() {
			//carica il prezzo del prodotto con le opzioni selezionate
			price.value = 0;
			let obj = {
				id: selectedProduct.value.id,
				color: encodeURIComponent(selectedColor.value.name),
				size: selectedSize.value,
			}
			let res = await productsMethods.getPriceAndVideo(obj);
			price.value = res.price;
			selectedProduct.value.videoApplicativo = res.video;
		}

		async function loadImage() {
			//carica l'immagine del prodotto
			imageSrc.value = imgPath + "loading.gif";
			let obj = {
				size: selectedSize.value.replace(",", ""),
				color: encodeURIComponent(selectedColor.value.name),
				id: selectedProduct.value.id
			}
			imageSrc.value = await productsMethods.getVariationImage(obj);
		}
		async function addToCartFissativo(){
			addingCart.value = true;
			let obj = {
				id:3413,
				quantity:1
			}
			let res = await productsMethods.addToCart(obj);
			if (res.items) {
				logCart.value = true;
			}
			addingCart.value = false;
		}
		async function addToCart() {
			//aggiunge il prodotto con le opzioni selezionate al carrello
			addingCart.value = true;
			let obj = {
				id: selectedProduct.value.id,
				quantity: quantità.value,
				variation: [{ attribute: selectedColor.value.taxonomy, value: selectedColor.value.name },
				{ attribute: "pa_dimensione", value: selectedSize.value }]
			}
			let res = await productsMethods.addToCart(obj);
			if (res.items) {
				logCart.value = true;
			}
			addingCart.value = false;
		}
		async function addManyToCart() {
			//aggiunge i prodotti selezionati nel simulatore di resa al carrello
			addingCart.value = true;
			let data = [];
			resa.value.forEach(element => {
				let obj = {
					id: selectedProduct.value.id,
					quantity: element.quantità,
					variation: [{ attribute: selectedColor.value.taxonomy, value: selectedColor.value.name },
					{ attribute: "pa_dimensione", value: element.confezionePost }]
				}
				if (obj.quantity > 0) {
					data.push(obj);
				}
			})
			let res = await productsMethods.addManyToCart(data);
			if (res.responses[0].body.items) {
				logCart.value = true;
			}
			addingCart.value = false;
		}

		function filterColors(centroidIndex) {
			//mostra i colori associati al centroide selezionato
			if (centroidIndex != 0) {
				filteredColors.value = [];
				colors.value.forEach((element, i) => {
					if (labelsAvailable.value[i] == centroidIndex) {
						filteredColors.value.push(element)
					}
				})
			}
			else {
				filteredColors.value = colors.value;
			}
		}

		function changeInput(input) {
			// inputMq.value = 0;
			// inputPareti.value = [];
			modInput.value = input;
		}

		function toTds() {
			window.location.href = `https://loggia.docs-online.it/pages/prodotto.php?titolo=${selectedProduct.value.tds}&lang=1`;
		}

		function toSds() {
			window.location.href = `https://loggia.docs-online.it/pages/prodotto.php?titolo=${selectedProduct.value.tds}&lang=1`;
		}

		function openPainter(){
			window.open(localStorage.getItem('linkPainter'),'_blank').focus();
		}
		watch(() => [selectedProduct.value, selectedPalette.value], () => {
			//carica i colori quando sono selezionati sia il prodotto sia la palette e uno dei due cambia
			if (selectedProduct.value && selectedPalette.value) {
				centroidsAvailable.value = [];
				filteredColors.value = [];
				if (selectedPalette.value !== true) {
					loadColors();
				}
			}
		})
		watch(() => [selectedProduct.value, selectedColor.value, selectedSize.value], () => {
			//carica il prezzo e l'immagine una volta che ho selezionato il prodotto, il colore e la dimensione
			if (selectedProduct.value && selectedColor.value && selectedSize.value) {
				Promise.all([loadImage(), getPriceAndVideo()])
			}
		})
		watch(() => colors.value, () => {
			//calcola i centroidi e assegna i colori ai centroidi
			let colorsRGB = [];
			//console.log(colors.value);
			colors.value.forEach(element => {
				if (element.taxonomy == 'pa_colore') {
					var r = parseInt(element.hexColor.slice(1, 3), 16),
						g = parseInt(element.hexColor.slice(3, 5), 16),
						b = parseInt(element.hexColor.slice(5, 7), 16);
					colorsRGB.push([r, g, b]);
				}
			})
			let Numcentroids = 8;
			if (colorsRGB.length <= Numcentroids) {
				Numcentroids = colorsRGB.length - 1;
			}
			if (colorsRGB.length > 0) {
				// vecchi metodi
				// const hues = colorsRGB.map(colorsMethods.calculateHue);
				// const data = colorsRGB.map((color, index) => [...color, hues[index]]);
				// const { centroids, labels } = colorsMethods.kMeans(data, Numcentroids, colorsMethods.initializeFixedCentroids);
				// console.log(centroids);
				// console.log(labels);
				// centroidsAvailable.value = centroids;
				// centroidsAvailable.value.unshift(["clear"]);
				// labelsAvailable.value = labels.map(function (val) { return ++val; });
				let maxAffinity = 50;
				let { clusters, colorClusterIndexMap } = colorsMethods.kMeansRGB(colorsRGB, maxAffinity);
				centroidsAvailable.value = clusters;
				centroidsAvailable.value.unshift(["clear"]);
				labelsAvailable.value = colorClusterIndexMap.map(function (val) { return ++val; });

			}

		})

		watch(() => logCart.value, async () => {
			if (logCart.value) {
				await delay(5000);
				logCart.value = false;
			}
		})

		watch(() => searchFilter.value, async () => {
			// console.log("filtrando")
			filteredColors.value.forEach(element => {
				if (!element.name.toLowerCase().includes(searchFilter.value.toLowerCase())) {
					element.show = false;
				}
				else {
					element.show = true;
				}
			})

		})

		const delay = ms => new Promise(res => setTimeout(res, ms));

		const priceTotal = computed(() => {
			//calcola il prezzo totale di tutte le confezioni selezionate
			let unit = price.value;
			let quantity = quantità.value;
			return Math.round(((unit * quantity) + Number.EPSILON) * 100) / 100;
		})
		const resa = computed(() => {
			//calcola le confezioni consigliate a partire dalla resa del prodotto e 
			let total = 0;
			if (modInput.value == "mq") {
				total = inputMq.value*inputMani.value;
			}
			if (modInput.value == "pareti") {
				inputPareti.value.forEach(element => {
					//total += (element.x * element.y) / 10000*inputMani.value;
					total += (element.x * element.y) * inputMani.value;
				})
			}
			let results = [];
			let options = sizes.value;
			options.sort(function (a, b) {
				return b.sizeValue - a.sizeValue;
			});
			options.forEach((element, i) => {
				let resa = resaF * element.sizeValue;
				let amountConf = Math.floor(total / resa);
				let resConf = total % resa;
				if (resConf > (resa * 1) / 2) {
					amountConf++;
					resConf = 0;
				}
				total = resConf;
				if (i === options.length - 1 && total > 0) {
					amountConf++;
					resConf = 0;
				}
				results.push({ confezione: element.sizeLabel, confezionePost: element.sizeFormValue, quantità: amountConf });
			});
			return results;
		});

		const prezzoCalc = computed(() => {
			//calcola il prezzo delle confezioni selezionate nel calcolatore di resa
			let total = 0;
			resa.value.forEach(element => {
				let amount = element.quantità;
				sizes.value.forEach(e => {
					if (e.sizeLabel === element.confezione) {
						total += amount * e.price
					}
				})
			})
			return total.toFixed(2);
		})


		return {
			palettes, colors, products, selectedProduct, selectedColor, selectedPalette, selectedSize, imageSrc, price,
			modInput, changeInput, inputPareti,
			modalPr, modalCo, sizes, prezzoCalc, inputMq, resa, quantità, priceTotal,inputMani,
			openModalPr, closeModalPr, openModalCo, closeModalCo, openModalResa, modalResa, closeModalResa,
			selectPr, selectPa, selectAllPa, selectCo, reset, addToCart, addManyToCart, selectSize, centroidsAvailable, labelsAvailable,
			filterColors, filteredColors, imgPath, logCart, addingCart, styleBackgroundLoading, searchFilter,
			toTds, toSds, scrollObj, visibleBottomBar,addToCartFissativo,openPainter
		}





	}
}
</script>
<style scoped>
button {
	margin: 1px;
}

nav {
	padding: 30px;
}

nav a {
	font-weight: bold;
	color: #2c3e50;
}

nav a.router-link-exact-active {
	color: #42b983;
}

.overlayActive {
	height: 100vh;
	width: 100vw;
	position: fixed;
	z-index: 9999;
	top: 0;
	left: 0;
	background-color: #0000007a;
	background-image: v-bind(styleBackgroundLoading);
	background-repeat: no-repeat;
	background-position-x: 50%;
	background-position-y: 50%;
	overflow-x: hidden;
	transition: 0.5s;
}

.button_plus {
	position: relative;
	width: 35px;
	height: 35px;
	background: #d3d4d5;
	cursor: pointer;
	border: 2px solid #fff;

	/* Mittig */
	top: 50%;
	left: 50%;
}

.button_plus:after {
	content: '';
	position: absolute;
	transform: translate(-50%, -50%);
	height: 4px;
	width: 50%;
	background: #000;
	top: 50%;
	left: 50%;
}

.button_plus:before {
	content: '';
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	background: #000;
	height: 50%;
	width: 4px;
}

.button_plus:hover:before,
.button_plus:hover:after {
	background: #fff;
	transition: 0.2s;
}

.button_plus:hover {
	background-color: #000;
	transition: 0.2s;
}

.button_minus {
	position: relative;
	width: 35px;
	height: 35px;
	background: #d3d4d5;
	cursor: pointer;
	border: 2px solid #fff;

	/* Mittig */
	top: 50%;
	left: 50%;
}

.button_minus:after {
	content: '';
	position: absolute;
	transform: translate(-50%, -50%);
	height: 4px;
	width: 50%;
	background: #000;
	top: 50%;
	left: 50%;
}

.button_minus:hover:before,
.button_minus:hover:after {
	background: #fff;
	transition: 0.2s;
}

.button_minus:hover {
	background-color: #000;
	transition: 0.2s;
}

.contWhite {
	background: white;
	box-shadow: 0px 0px 10px black;
}
</style>